// @flow

import React from 'react';

import {StyledStepContentSeparatorDiv} from 'app/procedures/components/structures';
import {StepTaskFieldWrapper} from './step-form-fields/StepTaskFieldWrapper';
import {StepFormFieldsTitle} from 'app/procedures/components/structures';
import type {AttachedFieldType} from 'app/general/types';
import type {TaskProgressStepFieldType} from 'app/tasks/types';

type Props = {|
  stepFields?: Array<AttachedFieldType>,
  fieldsProgress: {[string]: TaskProgressStepFieldType},
  blocked: boolean,
  inputListener: (fieldId: string, value: any) => Promise<any>,
|};

export class ProcedureStepFields extends React.PureComponent<Props> {
  static defaultProps = {
    blocked: false,
  };

  render() {
    const {stepFields, inputListener, blocked, fieldsProgress} = this.props;
    return stepFields != null && stepFields.length > 0 ? (
      <StyledStepContentSeparatorDiv className="files">
        <StepFormFieldsTitle />
        <ul className="list-group">
          {stepFields.map((field) => (
            <StepTaskFieldWrapper
              blocked={blocked}
              key={field.id}
              field={field}
              progress={fieldsProgress[field.id]}
              inputListener={inputListener}
            />
          ))}
        </ul>
      </StyledStepContentSeparatorDiv>
    ) : null;
  }
}
